import React, {} from 'react'

const UnfilledForm = props => {        
    const {content, step}  = props;
    return (
        <div className="inactive-step">
            <div className="text-step">Steg {step} av 4</div>
            <div className="text-title">{content.heading}</div>   
            <div className="text-desc">{content.desc}</div>
        </div>
    )    
}

export default UnfilledForm
